export default __webpack_public_path__ + "static/media/FC2影音.7bab392b.jpg";